import { useStorageUserConfigContext } from '@app/modules/UserConfig/contexts/storage';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

interface IModalProps {}

export const ModalAlert: FunctionComponent<IModalProps> = observer<FunctionComponent<IModalProps>>(function () {
    const { userConfigStore } = useStorageUserConfigContext();

    let openAlert = userConfigStore.openAlert;

    return (
        <Dialog open={openAlert} onClose={() => userConfigStore.handleCloseAlert()} aria-describedby='alert-dialog-description'>
            <DialogContent>
                <DialogContentText id='alert-dialog-description'>User already exists</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        userConfigStore.handleCloseAlert();
                    }}
                    size={'small'}
                    color='primary'>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
});
